<template>
  <div>
    <div
      class="item-container flex pointer"
      :class="{ selected: isSelected }"
      @click="select()"
    >
      <div class="badge-container">
        <badge
          :src="adulticide.badgeSrc"
          :shiftLeft="!adulticide.isActive"
        ></badge>
      </div>
      <div class="flex info-container">
        <div>{{ siteName }} - Truck {{ truckName }}</div>
        <small v-if="dateAndStartTime && endTime"
          >{{ dateAndStartTime }} to {{ endTime }}</small
        >
        <small v-else-if="dateAndStartTime === false">
          Failed to retrieve data
        </small>
        <small v-else>Loading..</small>
        <small>Applicator: {{ applicator }}</small>
      </div>
    </div>
    <div
      v-if="isSelected"
      class="item-container selected-info-container"
      :class="{ selected: isSelected }"
    >
      <div class="separator"></div>
      <div class="view-adulticide-form pointer">
        <router-link
          :to="{
            name: 'data-adulticide-details',
            params: { id: adulticide.id },
          }"
        >
          View Adulticide Form for this Spray Session
        </router-link>
      </div>
      <div v-if="dataPoint">
        <div class="hint">
          Use Left/Right Arrows to Move Through Path Data
        </div>
        <div class="property">
          <span class="property-label">Truck Speed: </span
          >{{ Math.round(dataPoint.speed) }} mph
        </div>
        <div class="property">
          <span class="property-label">Sprayer Status: </span>
          {{ dataPoint.pumpStatus ? 'On' : 'Off' }}
        </div>
        <div class="property">
          <span class="property-label">Data Point Timestamp: </span>
          {{ dateTimeToTimeStamp(dataPoint.timestamp) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Badge from '../../map/sidebar/badge.vue';
import Adulticide from '../../../services/AdulticideService';
import Truck from '../../../services/TrucksService';
import moment from 'moment';

export default {
  components: {
    Badge,
  },

  props: {
    adulticide: Object,
  },

  computed: {
    applicator() {
      return this.adulticide.applicator.name;
    },
    isSelected() {
      return (
        this.adulticide === this.$store.state.sprayPaths.selectedAdulticide
      );
    },
    dataPoint() {
      return this.$store.state.sprayPaths.pathDataPoint;
    },
    siteName() {
      return this.adulticide.zone.name;
    },
    truckName() {
      return this.adulticide.truck ? this.adulticide.truck.name : 'N/A';
    },
  },

  asyncComputed: {
    async applicationRate() {
      return new Promise((resolve) => {
        this.adulticide.requestApplicationRate(resolve);
      });
    },
    async dateAndStartTime() {
      const $this = this;
      return new Promise((resolve) => {
        this.adulticide.requestSpraySessionEntries((entries) => {
          const { length } = entries;
          if (length === 0) {
            resolve(false);
          }
          const firstEntry = entries[0];
          resolve(moment(firstEntry.timestamp).format('M/DD/YY - h:mm a'));
        });
      });
    },
    endTime() {
      const $this = this;
      return new Promise((resolve) => {
        this.adulticide.requestSpraySessionEntries((entries) => {
          const { length } = entries;
          if (length === 0) {
            resolve('');
          }
          const lastEntry = entries[entries.length - 1];
          resolve(moment(lastEntry.timestamp).format('h:mm a'));
        });
      });
    },
  },

  methods: {
    select() {
      const { adulticide } = this;
      this.$store.commit('setSelectedAdulticide', { adulticide });
    },
    dateTimeToTimeStamp(dateTime) {
      return moment(dateTime).format('h:mm:ss a');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/variables';

.item-container {
  padding: 1rem 0;

  &.selected {
    background-color: rgba(200, 210, 242, 0.25);
  }
}

.badge-container {
  margin: 0.5rem 0.25rem 0.25rem;
  padding-left: 1rem;
}

.info-container {
  flex-direction: column;
  margin-left: 0.75rem;
  & div {
    font-family: Roboto;
    font-size: 12.8px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: rgba(0, 0, 0, 0.87);
  }

  & small {
    font-family: Roboto;
    font-size: 9.6px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    color: $small-text-color;
  }
}

.selected-info-container {
  padding: 0 3rem 1rem;

  & .separator {
    border-top: solid 1px #c8d2f2;
    margin-bottom: 1rem;
  }
}

.view-adulticide-form {
  font-family: Roboto;
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  text-decoration: underline;
  line-height: 1.82;
  letter-spacing: normal;
  color: $blue;
  margin-bottom: 1rem;
}

.hint {
  font-family: Roboto;
  font-size: 11px;
  font-stretch: normal;
  line-height: 1.82;
  letter-spacing: normal;
  font-weight: normal;
  font-style: italic;
  line-height: normal;
  color: #757575;
  margin-bottom: 0.5rem;
}

.property-label {
  font-family: Roboto;
  font-size: 11px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.82;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.87);
}

.property {
  font-family: Roboto;
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.82;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.87);
}
</style>
